export const FileFeatureTypeEnum = {
  StudyArea: "study_area",
} as const;

export type FileFeatureTypeEnum = (typeof FileFeatureTypeEnum)[keyof typeof FileFeatureTypeEnum];

export const FileDataTypeEnum = {
  Schematisation: "threedi_schematisation",
  Ogc: "ogc_3d_tiles",
  Raster: "raster",
  Scenario: "scenario",
  Vector: "vector",
  Text: "text",
  Code: "code",
  Image: "image",
  Shapefile: "shapefile",
} as const;

export type FileDataTypeEnum = (typeof FileDataTypeEnum)[keyof typeof FileDataTypeEnum];
